import { useState, useEffect } from "react";
import { useLocation } from "wouter";

function getMoscowTime() {
  const now = new Date();
  const moscow = new Date(now.toLocaleString("en-US", { timeZone: "Europe/Moscow" }));
  return {
    day: moscow.getDay(),
    hours: moscow.getHours(),
    minutes: moscow.getMinutes(),
  };
}

function isLunchTime() {
  const { day, hours, minutes } = getMoscowTime();
  const isWeekday = day >= 1 && day <= 5;
  const afterNoon = hours >= 12;
  const before16 = hours < 16;
  return isWeekday && afterNoon && before16;
}

function getMinutesLeft() {
  const { hours, minutes } = getMoscowTime();
  return (16 - hours) * 60 - minutes;
}

export function LunchBanner() {
  const [visible, setVisible] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  const [minutesLeft, setMinutesLeft] = useState(0);
  const [, setLocation] = useLocation();

  useEffect(() => {
    const update = () => {
      if (!dismissed && isLunchTime()) {
        setVisible(true);
        setMinutesLeft(getMinutesLeft());
      } else {
        setVisible(false);
      }
    };
    update();
    const id = setInterval(update, 30000);
    return () => clearInterval(id);
  }, [dismissed]);

  if (!visible) return null;

  const hrs = Math.floor(minutesLeft / 60);
  const mins = minutesLeft % 60;
  const timeLabel = hrs > 0
    ? `${hrs} ч ${mins} мин`
    : `${mins} мин`;

  return (
    <div
      className="fixed left-0 right-0 z-[59] bg-primary text-primary-foreground top-[calc(96px+var(--ny-bar-h,0px))] md:top-[calc(112px+var(--ny-bar-h,0px))]"
    >
      <div className="container mx-auto px-4 md:px-14 flex items-center justify-between gap-3 py-2.5">
        <div className="flex items-center gap-3 text-[11px] md:text-xs tracking-wide font-light">
          <span className="hidden sm:inline-block w-1.5 h-1.5 rounded-full bg-accent animate-pulse shrink-0" />
          <span>
            <span className="font-medium">Бизнес-ланч сейчас</span>
            <span className="opacity-75"> · Пн–Пт 12:00–16:00 · от 590 ₽</span>
          </span>
          <span className="hidden md:inline text-accent font-medium">
            Осталось {timeLabel}
          </span>
        </div>
        <div className="flex items-center gap-3 shrink-0">
          <button
            onClick={() => setLocation("/menu")}
            className="text-[9px] tracking-[0.25em] uppercase border border-primary-foreground/40 px-4 py-1.5 hover:bg-primary-foreground/10 transition-colors whitespace-nowrap"
          >
            Смотреть меню
          </button>
          <button
            onClick={() => setDismissed(true)}
            className="opacity-50 hover:opacity-100 transition-opacity p-1"
            aria-label="Закрыть"
          >
            <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
              <line x1="1" y1="1" x2="11" y2="11" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
              <line x1="11" y1="1" x2="1" y2="11" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
            </svg>
          </button>
        </div>
      </div>
    </div>
  );
}
